import { useRef, useEffect, useState } from 'react';
import { useLatest } from 'shared/ui/useLatest';
export const useStickyBottomScroll = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [manual, setManual] = useState(false);
  const latest = useLatest({
    manual
  });
  const scrollToBottom = () => {
    const div = ref.current;
    const {
      manual: manual_0
    } = latest.current;
    if (div && !isAtBottom(div)) {
      div.scrollTo({
        top: div.scrollHeight
      }); //, behavior: 'smooth' . I want smooth but it causes issues (doesn't detect manual before scrolling to bottom again)
    }
    if (manual_0) setManual(false);
  };
  useEffect(() => {
    const div_0 = ref.current;
    const handleScroll = () => {
      if (!div_0) return;
      const {
        manual: manual_1
      } = latest.current;
      const atBottom = isAtBottom(div_0);
      if (atBottom == manual_1) setManual(!manual_1);
    };
    const observeContentChanges = () => {
      if (div_0) {
        const observer = new MutationObserver(m => {
          const {
            manual: manual_2
          } = latest.current;
          if (!manual_2) scrollToBottom();
        });
        observer.observe(div_0, {
          childList: true,
          subtree: true
        });
        return () => observer.disconnect();
      }
    };
    if (div_0) {
      div_0.addEventListener('scroll', handleScroll);
      scrollToBottom();
      observeContentChanges();
    }
    return () => {
      if (div_0) div_0.removeEventListener('scroll', handleScroll);
    };
  }, [ref.current]);
  return {
    ref,
    scrollToBottom,
    scrollingManual: manual
  };
};
const isAtBottom = (div: HTMLDivElement) => div.scrollTop + div.clientHeight >= div.scrollHeight - 1; /*it doesn't seem aurate so give it within 1px*/ //it doesn't seem aurate so give it within 1px